import { NavLink } from "react-router-dom";
import MyImage from './logo192.png'; 

function NavBar() {
  return (
    <>
      <div className="App-header">

        <img src={MyImage} alt="logo" />
        <h2><b>Oberman Financial Coaching</b></h2> <br></br>
        <h3><i>Coaching you to a financial victory!</i></h3>
        <NavLink className="main-nav-link" to={"/"}> Home </NavLink>
        <NavLink className="main-nav-link" to={"/about"}> About </NavLink>
        <NavLink className="main-nav-link" to={"/services"}> Services </NavLink>
        <NavLink className="main-nav-link" to={"/faq"}> FAQ </NavLink>
        <NavLink className="main-nav-link" to={"/contact"}> Contact </NavLink>
      </div>
    </>
  );
}

export default NavBar;
